import moment from 'moment';

export const convertUnixTimestamp = (timestamp: number) => {
  const date = new Date(timestamp * 1000);

  const optionsDate: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };

  const optionsTime: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
  };

  const optionsTimeZone: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
    timeZoneName: 'short',
  };

  const optionsTimeFullDate: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
    hour12: false,
  };

  const optionsDayAndMonth: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: '2-digit',
  };

  const customFormattedDate: string = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);

  const formattedDayAndMonth = date.toLocaleString('en-GB', optionsDayAndMonth);
  const formattedDate = date.toLocaleString('en-GB', optionsDate);
  const formattedTime = date.toLocaleTimeString('en-GB', optionsTime);
  const formattedTimeZone = date.toLocaleString('en-GB', optionsTimeZone);
  const formattedFullDate = date.toLocaleString('en-GB', optionsTimeFullDate);

  // New format
  const optionsNewFormatDate: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: '2-digit',
  };

  const optionsNewFormatTime: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
    hour12: false,
  };

  const formattedNewDate = date.toLocaleDateString(
    'en-GB',
    optionsNewFormatDate,
  );
  const formattedNewTime = date.toLocaleTimeString(
    'en-GB',
    optionsNewFormatTime,
  );
  const newFormat = `${formattedNewDate}, ${formattedNewTime}`;

  const momentDate = moment.unix(timestamp);
  const dayOfWeekDate = momentDate.format('dddd D/M');

  return {
    fullDate: `${formattedFullDate}`,
    formattedDate: `${customFormattedDate}`,
    date: `${formattedDate}`,
    time: `${formattedTime}`,
    timeWithZone: `${formattedTimeZone}`,
    formattedDayAndMonth: `${formattedDayAndMonth}`,
    rawDate: Intl.DateTimeFormat('en-GB', optionsTimeFullDate),
    newFormat,
    dayOfWeekDate,
  };
};
